"use client";

import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { format } from "date-fns";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import NoResult from "@/assets/images/common/no-result.png";
import ActivityIcon from "@/assets/svg/activity.svg";
import CalendarIcon from "@/assets/svg/calendar.svg";
import { PopLoading } from "@/components/pop-ui/pop-loading";
import { toast } from "@/components/pop-ui/pop-toast";
import { PullToRefreshWrapper } from "@/components/ui/pull-to-refresh";
import { useIsMobile } from "@/hooks/use-mobile";
import { convertToTimezone } from "@/lib/utils";
import { getValueFromTranslations, useLocaleRouter } from "@/lib/utils.client";
import { useORPC } from "@/providers/orpc-provider";
import Empty from "./components/empty";
import { ModulePagination } from "./components/module-pagination";
import { ModuleTabs } from "./components/module-tabs";
import { ModuleTitle } from "./components/module-title";
export enum Status {
  CONFIRMED = "CONFIRMED",
  // 预约成功
  USED = "USED",
  // 已核销
  CANCELLED = "CANCELLED",
  // 预约取消
  FAILED = "FAILED",
  // 预约失败
  EXPIRED = "EXPIRED" // 已过期
  ,
}
export function RegistrationsModule(t0) {
  const $ = _c(102);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onHeaderContentChange
  } = t1;
  const {
    t
  } = useTranslation();
  const orpc = useORPC();
  const isMobile = useIsMobile();
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState("pending");
  const [currentPage, setCurrentPage] = useState(1);
  let t2;
  if ($[2] !== activeTab || $[3] !== currentPage || $[4] !== orpc.activity.userFlashRegistration.findMyRegistrations) {
    t2 = orpc.activity.userFlashRegistration.findMyRegistrations.queryOptions({
      input: {
        page: currentPage,
        pageSize: 20,
        status: activeTab === "pending" ? Status.CONFIRMED : undefined,
        neStatus: activeTab === "pending" ? undefined : Status.CONFIRMED
      } as any
    });
    $[2] = activeTab;
    $[3] = currentPage;
    $[4] = orpc.activity.userFlashRegistration.findMyRegistrations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      ...t2
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: registrationsResponse,
    isLoading,
    isError,
    refetch
  } = useQuery(t3);
  let t4;
  if ($[8] !== registrationsResponse?.items) {
    t4 = registrationsResponse?.items || [];
    $[8] = registrationsResponse?.items;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const registrations = t4;
  const totalPages = registrationsResponse?.totalPages || 1;
  let t5;
  if ($[10] !== registrations) {
    t5 = registrations.map(_temp).filter(Boolean);
    $[10] = registrations;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const registrationIds = t5;
  let t6;
  if ($[12] !== registrationIds) {
    t6 = ["userFlashRegistration", "withActivity", registrationIds];
    $[12] = registrationIds;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== orpc.activity.userFlashRegistration.getUserFlashRegistrationWithActivityById || $[15] !== registrationIds) {
    t7 = async () => {
      const results = await Promise.all(registrationIds.map(id => orpc.activity.userFlashRegistration.getUserFlashRegistrationWithActivityById.call({
        id
      }).catch(_temp2)));
      return results.filter(Boolean);
    };
    $[14] = orpc.activity.userFlashRegistration.getUserFlashRegistrationWithActivityById;
    $[15] = registrationIds;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = registrationIds.length > 0;
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = {
      queryKey: t6,
      queryFn: t7,
      enabled: t8,
      staleTime: 60000
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const {
    data: t10
  } = useQuery(t9);
  let t11;
  if ($[21] !== t10) {
    t11 = t10 === undefined ? [] : t10;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const registrationWithActivity = t11;
  let map;
  if ($[23] !== registrationWithActivity) {
    map = new Map();
    for (const item of registrationWithActivity as any[]) {
      if (!item) {
        continue;
      }
      map.set(item.id, item.flashRegistration || null);
    }
    $[23] = registrationWithActivity;
    $[24] = map;
  } else {
    map = $[24];
  }
  const activityByRegistrationId = map;
  let storeIds;
  let t12;
  let t13;
  if ($[25] !== orpc.store.findByIds || $[26] !== registrations) {
    storeIds = registrations.map(_temp3).filter(_temp4).filter(_temp5);
    t13 = useQuery;
    t12 = orpc.store.findByIds.queryOptions({
      input: {
        ids: storeIds
      } as any
    });
    $[25] = orpc.store.findByIds;
    $[26] = registrations;
    $[27] = storeIds;
    $[28] = t12;
    $[29] = t13;
  } else {
    storeIds = $[27];
    t12 = $[28];
    t13 = $[29];
  }
  const t14 = storeIds.length > 0;
  let t15;
  if ($[30] !== t12 || $[31] !== t14) {
    t15 = {
      ...t12,
      enabled: t14,
      staleTime: 0
    };
    $[30] = t12;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const {
    data: t16,
    isLoading: isLoadingStores,
    error: storesError
  } = t13(t15);
  let t17;
  if ($[33] !== t16) {
    t17 = t16 === undefined ? [] : t16;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const stores = t17;
  let t18;
  if ($[35] !== orpc.activity) {
    t18 = async registrationId => await orpc.activity.userFlashRegistration.userCancelRegistration.call({
      id: registrationId
    });
    $[35] = orpc.activity;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== queryClient || $[38] !== refetch || $[39] !== t) {
    t19 = async () => {
      toast.success(t("account.registrations.toast.cancelSuccess", "\u9884\u7EA6\u53D6\u6D88\u6210\u529F"));
      await refetch();
      queryClient.invalidateQueries({
        queryKey: ["userFlashRegistration", "findMyRegistrations"]
      });
    };
    $[37] = queryClient;
    $[38] = refetch;
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = error => {
      console.error("\u53D6\u6D88\u9884\u7EA6\u5931\u8D25:", error);
      toast.error(t("account.registrations.toast.cancelError", "\u9884\u7EA6\u53D6\u6D88\u5931\u8D25"));
    };
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t18 || $[44] !== t19 || $[45] !== t20) {
    t21 = {
      mutationFn: t18,
      onSuccess: t19,
      onError: t20
    };
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const cancelRegistrationMutation = useMutation(t21);
  let t22;
  if ($[47] !== cancelRegistrationMutation) {
    t22 = async registrationId_0 => {
      cancelRegistrationMutation.mutate(registrationId_0);
    };
    $[47] = cancelRegistrationMutation;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  const handleCancelRegistration = t22;
  let t23;
  if ($[49] !== refetch) {
    t23 = async () => {
      await refetch();
    };
    $[49] = refetch;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  const handleRefresh = t23;
  let t24;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = page => {
      setCurrentPage(page);
    };
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  const handlePageChange = t24;
  let t25;
  if ($[52] !== refetch) {
    t25 = () => {
      setCurrentPage(1);
      refetch();
    };
    $[52] = refetch;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== activeTab) {
    t26 = [activeTab];
    $[54] = activeTab;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  useEffect(t25, t26);
  let t27;
  if ($[56] !== isMobile || $[57] !== onHeaderContentChange) {
    t27 = () => {
      if (isMobile && onHeaderContentChange) {
        onHeaderContentChange(null);
      }
    };
    $[56] = isMobile;
    $[57] = onHeaderContentChange;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== activeTab || $[60] !== isMobile || $[61] !== onHeaderContentChange || $[62] !== t) {
    t28 = [activeTab, isMobile, onHeaderContentChange, t];
    $[59] = activeTab;
    $[60] = isMobile;
    $[61] = onHeaderContentChange;
    $[62] = t;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  useEffect(t27, t28);
  let t29;
  if ($[64] !== t) {
    t29 = t("account.registrations.tabs.pending");
    $[64] = t;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t29) {
    t30 = {
      key: "pending" as const,
      label: t29
    };
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t) {
    t31 = t("account.registrations.tabs.history");
    $[68] = t;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== t31) {
    t32 = {
      key: "history" as const,
      label: t31
    };
    $[70] = t31;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== t30 || $[73] !== t32) {
    t33 = [t30, t32];
    $[72] = t30;
    $[73] = t32;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  const TABS = t33;
  let t34;
  if ($[75] !== TABS || $[76] !== activeTab || $[77] !== isMobile || $[78] !== t) {
    t34 = !isMobile && <><ModuleTitle title={t("account.registrations.title", "\u6211\u7684\u9884\u7EA6")} /><ModuleTabs tabs={TABS} activeKey={activeTab} onChange={key => setActiveTab(key as "pending" | "history")} /></>;
    $[75] = TABS;
    $[76] = activeTab;
    $[77] = isMobile;
    $[78] = t;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  const desktopHeaderDom = t34;
  let t35;
  if ($[80] !== activeTab || $[81] !== activityByRegistrationId || $[82] !== cancelRegistrationMutation || $[83] !== currentPage || $[84] !== desktopHeaderDom || $[85] !== handleCancelRegistration || $[86] !== isError || $[87] !== isLoading || $[88] !== isLoadingStores || $[89] !== isMobile || $[90] !== registrations || $[91] !== stores || $[92] !== storesError || $[93] !== t || $[94] !== totalPages) {
    t35 = () => {
      if (isLoading) {
        return <div className={isMobile ? "min-h-screen" : "min-h-[500px]"}>{desktopHeaderDom}<div className={`flex items-center justify-center py-8 ${isMobile ? "px-3" : ""}`}><PopLoading /></div></div>;
      }
      if (registrations.length === 0 || isError) {
        return <div className={isMobile ? "min-h-screen" : ""}>{desktopHeaderDom}<div className={isMobile ? "px-3 py-4" : ""}><Empty src={NoResult} title={t("account.registrations.emptyText", {
              status: activeTab === "pending" ? t("account.registrations.tabs.pending") : t("account.registrations.tabs.history")
            })} /></div></div>;
      }
      return <>{desktopHeaderDom}<div className="w-full"><div className="space-y-2 md:space-y-4 md:bg-white bg-[#F5F5F5]">{registrations.map(registration => <RegistrationItem key={registration.id} registration={registration} activity={activityByRegistrationId.get(registration.id)} stores={stores} isLoadingStores={isLoadingStores} storesError={storesError} onCancel={handleCancelRegistration} isCancelling={cancelRegistrationMutation.isPending} />)}</div></div><div className={isMobile ? "px-3 pb-4" : ""}><ModulePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} /></div></>;
    };
    $[80] = activeTab;
    $[81] = activityByRegistrationId;
    $[82] = cancelRegistrationMutation;
    $[83] = currentPage;
    $[84] = desktopHeaderDom;
    $[85] = handleCancelRegistration;
    $[86] = isError;
    $[87] = isLoading;
    $[88] = isLoadingStores;
    $[89] = isMobile;
    $[90] = registrations;
    $[91] = stores;
    $[92] = storesError;
    $[93] = t;
    $[94] = totalPages;
    $[95] = t35;
  } else {
    t35 = $[95];
  }
  const contentDom = t35;
  let t36;
  if ($[96] !== activeTab || $[97] !== contentDom || $[98] !== handleRefresh || $[99] !== isMobile || $[100] !== t) {
    t36 = isMobile ? <div className="min-h-screen bg-[#F5F5F5]"><div className="relative border-b  border-gray-[#CCCCCC]"><div className="grid grid-cols-2 gap-0 bg-white"><button type="button" onClick={() => setActiveTab("pending")} className="text-base font-regular transition-colors duration-200 text-center text-nowrap pt-4 pb-2 relative"><span className={`inline-block ${activeTab === "pending" ? "text-destructive font-medium" : "text-gray-500 hover:text-gray-700"}`}>{t("account.registrations.tabs.pending", "PENDING")}</span>{activeTab === "pending" && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-destructive w-8" />}</button><button type="button" onClick={() => setActiveTab("history")} className="text-base font-regular transition-colors duration-200 text-center text-nowrap pt-4 pb-2 relative"><span className={`inline-block ${activeTab === "history" ? "text-destructive font-medium" : "text-gray-500 hover:text-gray-700"}`}>{t("account.registrations.tabs.history", "HISTORY")}</span>{activeTab === "history" && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-destructive w-8" />}</button></div></div><PullToRefreshWrapper onRefresh={handleRefresh}>{contentDom()}</PullToRefreshWrapper></div> : <div className={isMobile ? "min-h-screen" : ""}>{contentDom()}</div>;
    $[96] = activeTab;
    $[97] = contentDom;
    $[98] = handleRefresh;
    $[99] = isMobile;
    $[100] = t;
    $[101] = t36;
  } else {
    t36 = $[101];
  }
  return t36;
}

// 预约项目组件
function _temp5(id_1, index, arr) {
  return arr.indexOf(id_1) === index;
}
function _temp4(id_0) {
  return id_0;
}
function _temp3(reg) {
  return reg.storeId;
}
function _temp2() {
  return null;
}
function _temp(r) {
  return r.id;
}
function RegistrationItem(t0) {
  const $ = _c(127);
  const {
    registration,
    activity,
    stores,
    isLoadingStores,
    storesError,
    onCancel,
    isCancelling
  } = t0;
  const {
    t,
    i18n
  } = useTranslation();
  const router = useLocaleRouter();
  const isMobile = useIsMobile();
  const locationTextRef = useRef(null);
  const dateTextRef = useRef(null);
  const [locationSingleLine, setLocationSingleLine] = useState(false);
  const [dateSingleLine, setDateSingleLine] = useState(false);
  const measureSingleLine = _temp6;
  let t1;
  if ($[0] !== isMobile) {
    t1 = () => {
      if (!isMobile) {
        return;
      }
      setLocationSingleLine(measureSingleLine(locationTextRef.current));
    };
    $[0] = isMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLoadingStores || $[3] !== isMobile || $[4] !== registration.storeId || $[5] !== stores || $[6] !== storesError) {
    t2 = [isMobile, isLoadingStores, storesError, stores, registration.storeId];
    $[2] = isLoadingStores;
    $[3] = isMobile;
    $[4] = registration.storeId;
    $[5] = stores;
    $[6] = storesError;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== isMobile) {
    t3 = () => {
      if (!isMobile) {
        return;
      }
      setDateSingleLine(measureSingleLine(dateTextRef.current));
    };
    $[8] = isMobile;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isMobile || $[11] !== registration.endTime || $[12] !== registration.reservationDate || $[13] !== registration.session || $[14] !== registration.startTime) {
    t4 = [isMobile, registration.startTime, registration.endTime, registration.reservationDate, registration.session];
    $[10] = isMobile;
    $[11] = registration.endTime;
    $[12] = registration.reservationDate;
    $[13] = registration.session;
    $[14] = registration.startTime;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[16] !== isMobile) {
    t5 = () => {
      if (!isMobile) {
        return;
      }
      const recompute = () => {
        setLocationSingleLine(measureSingleLine(locationTextRef.current));
        setDateSingleLine(measureSingleLine(dateTextRef.current));
      };
      const ro = new ResizeObserver(() => {
        recompute();
      });
      if (locationTextRef.current) {
        ro.observe(locationTextRef.current);
      }
      if (dateTextRef.current) {
        ro.observe(dateTextRef.current);
      }
      window.addEventListener("resize", recompute);
      recompute();
      return () => {
        ro.disconnect();
        window.removeEventListener("resize", recompute);
      };
    };
    t6 = [isMobile];
    $[16] = isMobile;
    $[17] = t5;
    $[18] = t6;
  } else {
    t5 = $[17];
    t6 = $[18];
  }
  useEffect(t5, t6);
  const hasPointsInfo = activity?.activityType === "points" && (activity?.pointsDeduction || 0) > 0;
  let t7;
  if ($[19] !== registration.id || $[20] !== router) {
    t7 = () => {
      router.push(`/flash-sale/reservation-result?id=${registration.id}&source=account`);
    };
    $[19] = registration.id;
    $[20] = router;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const handleViewRegistration = t7;
  let t8;
  if ($[22] !== i18n.language || $[23] !== t) {
    t8 = registration_0 => {
      const currentLanguage = i18n.language;
      if (registration_0.sessionNameTrans && Object.keys(registration_0.sessionNameTrans).length > 0) {
        return getValueFromTranslations(currentLanguage, registration_0.sessionNameTrans);
      }
      if (registration_0.sessionName) {
        return registration_0.sessionName;
      }
      if (registration_0.session && registration_0.session.name) {
        return registration_0.session.name;
      }
      return t("account.registrations.item.defaultSession", "\u9ED8\u8BA4\u573A\u6B21");
    };
    $[22] = i18n.language;
    $[23] = t;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const getSessionName = t8;
  let t9;
  if ($[25] !== t) {
    t9 = status => {
      switch (status) {
        case Status.CONFIRMED:
          {
            return t("account.registrations.status.confirmed", "CONFIRMED");
          }
        case Status.USED:
          {
            return t("account.registrations.status.used", "USED");
          }
        case Status.CANCELLED:
          {
            return t("account.registrations.status.cancelled", "CANCELLED");
          }
        case Status.FAILED:
          {
            return t("account.registrations.status.failed", "FAILED");
          }
        case Status.EXPIRED:
          {
            return t("account.registrations.status.expired", "EXPIRED");
          }
        default:
          {
            return status;
          }
      }
    };
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const getTranslatedStatus = t9;
  let t10;
  if ($[27] !== isLoadingStores || $[28] !== registration.storeId || $[29] !== stores || $[30] !== storesError) {
    t10 = () => {
      if (isLoadingStores) {
        return "";
      }
      if (storesError || !stores.length) {
        return "";
      }
      const store = stores.find(s => s.id === registration.storeId);
      return store?.storeTimezone || "";
    };
    $[27] = isLoadingStores;
    $[28] = registration.storeId;
    $[29] = stores;
    $[30] = storesError;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  const getTimezoneText = t10;
  let t11;
  if ($[32] !== getSessionName || $[33] !== getTimezoneText || $[34] !== registration || $[35] !== t) {
    t11 = () => {
      const {
        startTime,
        endTime,
        reservationDate
      } = registration;
      const sessionName = getSessionName(registration);
      const timezone = getTimezoneText();
      if (startTime && endTime) {
        const startDate = convertToTimezone(startTime as any, timezone || "");
        const endDate = convertToTimezone(endTime as any, timezone || "");
        if (startDate.toDateString() === endDate.toDateString()) {
          const dateStr = format(startDate, "yyyy.MM.dd");
          const startTimeStr = format(startDate, "HH:mm");
          const endTimeStr = format(endDate, "HH:mm");
          return `${dateStr} ${startTimeStr}-${endTimeStr}${timezone ? ` (${timezone.replace(/\\\\/g, "/")})` : ""} - ${sessionName}`;
        } else {
          const startDateStr = format(startDate, "yyyy.MM.dd HH:mm");
          const endDateStr = format(endDate, "yyyy.MM.dd HH:mm");
          return `${startDateStr}-${endDateStr}${timezone ? ` (${timezone.replace(/\\\\/g, "/")})` : ""} - ${sessionName}`;
        }
      } else {
        if (reservationDate) {
          const date = new Date(reservationDate);
          const dateStr_0 = format(date, "yyyy.MM.dd");
          return `${dateStr_0}${timezone ? ` (${timezone.replace(/\\\\/g, "/")})` : ""} - ${sessionName}`;
        }
      }
      return t("account.registrations.item.noTime", "\u65F6\u95F4\u5F85\u5B9A");
    };
    $[32] = getSessionName;
    $[33] = getTimezoneText;
    $[34] = registration;
    $[35] = t;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  const formatTimeRange = t11;
  let t12;
  if ($[37] !== isLoadingStores || $[38] !== registration.storeId || $[39] !== stores || $[40] !== storesError || $[41] !== t) {
    t12 = () => {
      if (isLoadingStores) {
        return t("account.registrations.item.loading", "\u52A0\u8F7D\u4E2D...");
      }
      if (storesError || !stores.length) {
        return registration.storeId ? `Store ${registration.storeId.slice(-8)}` : t("account.registrations.item.noLocation", "\u5730\u70B9\u5F85\u5B9A");
      }
      const store_0 = stores.find(s_0 => s_0.id === registration.storeId);
      return store_0?.address || t("account.registrations.item.noLocation", "\u5730\u70B9\u5F85\u5B9A");
    };
    $[37] = isLoadingStores;
    $[38] = registration.storeId;
    $[39] = stores;
    $[40] = storesError;
    $[41] = t;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  const getLocationText = t12;
  let t13;
  if ($[43] !== getTimezoneText || $[44] !== registration) {
    t13 = () => {
      const {
        startTime: startTime_0,
        endTime: endTime_0,
        reservationDate: reservationDate_0
      } = registration;
      const timezone_0 = getTimezoneText();
      const storeNow = convertToTimezone(new Date(), timezone_0 || "");
      if (startTime_0) {
        const storeStart = convertToTimezone(startTime_0 as any, timezone_0 || "");
        return storeStart.toDateString() === storeNow.toDateString();
      }
      if (endTime_0) {
        const storeEnd = convertToTimezone(endTime_0 as any, timezone_0 || "");
        return storeEnd.toDateString() === storeNow.toDateString();
      }
      if (reservationDate_0) {
        const storeDate = convertToTimezone(reservationDate_0 as any, timezone_0 || "");
        return storeDate.toDateString() === storeNow.toDateString();
      }
      return false;
    };
    $[43] = getTimezoneText;
    $[44] = registration;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  const isSessionToday = t13;
  const t14 = `font-regular text-sm md:hidden uppercase mb-4 md:mb-2 ${[Status.USED, Status.EXPIRED, Status.CANCELLED].includes(registration.status) ? "text-[#666666]" : "text-black"}`;
  let t15;
  if ($[46] !== getTranslatedStatus || $[47] !== registration.status) {
    t15 = getTranslatedStatus(registration.status);
    $[46] = getTranslatedStatus;
    $[47] = registration.status;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== t14 || $[50] !== t15) {
    t16 = <span className={t14}>{t15}</span>;
    $[49] = t14;
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== registration.activityName || $[53] !== t) {
    t17 = registration.activityName || t("account.registrations.item.eventName", "Event Name");
    $[52] = registration.activityName;
    $[53] = t;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== t17) {
    t18 = <h3 className="font-medium text-sm md:text-base text-black flex-1 mr-4">{t17}</h3>;
    $[55] = t17;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  const t19 = `hidden md:block font-medium text-base uppercase ${[Status.USED, Status.EXPIRED, Status.CANCELLED].includes(registration.status) ? "text-[#666666]" : "text-black"}`;
  let t20;
  if ($[57] !== getTranslatedStatus || $[58] !== registration.status) {
    t20 = getTranslatedStatus(registration.status);
    $[57] = getTranslatedStatus;
    $[58] = registration.status;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== t19 || $[61] !== t20) {
    t21 = <span className={t19}>{t20}</span>;
    $[60] = t19;
    $[61] = t20;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] !== t16 || $[64] !== t18 || $[65] !== t21) {
    t22 = <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-3">{t16}{t18}{t21}</div>;
    $[63] = t16;
    $[64] = t18;
    $[65] = t21;
    $[66] = t22;
  } else {
    t22 = $[66];
  }
  const t23 = `flex ${isMobile ? locationSingleLine ? "items-center" : "items-start" : "items-start"} mb-3 ${hasPointsInfo ? "md:mb-2" : "md:mb-0"} md:items-center`;
  const t24 = `w-4 h-4 md:w-8 md:h-8 mr-[4px] md:mr-[8px] shrink-0 ${isMobile && locationSingleLine ? "self-center" : "self-start"} ${!locationSingleLine ? "mt-[2px]" : ""}`;
  let t25;
  if ($[67] !== t24) {
    t25 = <ActivityIcon className={t24} />;
    $[67] = t24;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== getLocationText) {
    t26 = getLocationText();
    $[69] = getLocationText;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t26) {
    t27 = <span ref={locationTextRef} className="font-regular text-xs md:text-sm font-normal text-black leading-relaxed break-words min-h-[16px] md:min-h-[32px] flex items-center md:max-w-[calc(100%-220px)]">{t26}</span>;
    $[71] = t26;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t23 || $[74] !== t25 || $[75] !== t27) {
    t28 = <div className={t23}>{t25}{t27}</div>;
    $[73] = t23;
    $[74] = t25;
    $[75] = t27;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  const t29 = `flex ${isMobile ? dateSingleLine ? "items-center" : "items-start" : "items-start"} mb-3 ${hasPointsInfo ? "md:mb-2" : "md:mb-0"} md:items-center`;
  const t30 = `w-4 h-4 md:w-8 md:h-8 mr-[4px] md:mr-[8px] shrink-0 ${isMobile && dateSingleLine ? "self-center" : "self-start"} ${!dateSingleLine ? "mt-[2px]" : ""}`;
  let t31;
  if ($[77] !== t30) {
    t31 = <CalendarIcon className={t30} />;
    $[77] = t30;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== formatTimeRange) {
    t32 = formatTimeRange();
    $[79] = formatTimeRange;
    $[80] = t32;
  } else {
    t32 = $[80];
  }
  let t33;
  if ($[81] !== t32) {
    t33 = <span ref={dateTextRef} className="font-regular text-xs md:text-sm font-normal text-black leading-relaxed wrap-break-word min-h-[16px] md:min-h-[32px] flex items-center md:flex-1 md:pr-4 md:max-w-[calc(100%-220px)]">{t32}</span>;
    $[81] = t32;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== handleViewRegistration || $[84] !== hasPointsInfo || $[85] !== isCancelling || $[86] !== isSessionToday || $[87] !== onCancel || $[88] !== registration.id || $[89] !== registration.status || $[90] !== t) {
    t34 = !hasPointsInfo && <div className="hidden md:flex gap-2 ml-auto">{registration.status === Status.CONFIRMED && !isSessionToday() && <button type="button" onClick={() => onCancel(registration.id)} disabled={isCancelling} className="w-22 h-8 border border-black text-black font-medium md:text-sm text-xs md:hover:bg-black md:hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed">{isCancelling ? t("account.registrations.actions.cancelling", "CANCELLING...") : t("account.registrations.actions.cancel", "CANCEL")}</button>}<button type="button" onClick={handleViewRegistration} className="w-22 h-8 bg-black text-white font-medium text-xs md:text-sm md:hover:bg-[#1C1C1C] transition-colors">{t("account.registrations.actions.view", "VIEW")}</button></div>;
    $[83] = handleViewRegistration;
    $[84] = hasPointsInfo;
    $[85] = isCancelling;
    $[86] = isSessionToday;
    $[87] = onCancel;
    $[88] = registration.id;
    $[89] = registration.status;
    $[90] = t;
    $[91] = t34;
  } else {
    t34 = $[91];
  }
  let t35;
  if ($[92] !== t29 || $[93] !== t31 || $[94] !== t33 || $[95] !== t34) {
    t35 = <div className={t29}>{t31}{t33}{t34}</div>;
    $[92] = t29;
    $[93] = t31;
    $[94] = t33;
    $[95] = t34;
    $[96] = t35;
  } else {
    t35 = $[96];
  }
  let t36;
  if ($[97] !== activity || $[98] !== handleViewRegistration || $[99] !== isCancelling || $[100] !== isSessionToday || $[101] !== onCancel || $[102] !== registration.id || $[103] !== registration.status || $[104] !== t) {
    t36 = activity?.activityType === "points" && activity?.pointsDeduction > 0 && <div className="flex items-start md:items-center mb-3 md:mb-0"><span className="font-regular text-xs md:text-sm font-normal text-black leading-relaxed md:flex-1 md:pr-4 md:max-w-[calc(100%-220px)] break-words">{t("reservation_confirmation.cost_points", {
          points: activity.pointsDeduction
        })}</span><div className="hidden md:flex gap-2 ml-auto">{registration.status === Status.CONFIRMED && !isSessionToday() && <button type="button" onClick={() => onCancel(registration.id)} disabled={isCancelling} className="w-22 h-8 border border-black text-black font-medium md:text-sm text-xs md:hover:bg-black md:hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed">{isCancelling ? t("account.registrations.actions.cancelling", "CANCELLING...") : t("account.registrations.actions.cancel", "CANCEL")}</button>}<button type="button" onClick={handleViewRegistration} className="w-22 h-8 bg-black text-white font-medium text-xs md:text-sm md:hover:bg-[#1C1C1C] transition-colors">{t("account.registrations.actions.view", "VIEW")}</button></div></div>;
    $[97] = activity;
    $[98] = handleViewRegistration;
    $[99] = isCancelling;
    $[100] = isSessionToday;
    $[101] = onCancel;
    $[102] = registration.id;
    $[103] = registration.status;
    $[104] = t;
    $[105] = t36;
  } else {
    t36 = $[105];
  }
  let t37;
  if ($[106] !== isCancelling || $[107] !== isSessionToday || $[108] !== onCancel || $[109] !== registration.id || $[110] !== registration.status || $[111] !== t) {
    t37 = registration.status === Status.CONFIRMED && !isSessionToday() && <button type="button" onClick={() => onCancel(registration.id)} disabled={isCancelling} className="w-22 h-8 border border-black text-black font-medium md:text-sm text-xs hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">{isCancelling ? t("account.registrations.actions.cancelling", "CANCELLING...") : t("account.registrations.actions.cancel", "CANCEL")}</button>;
    $[106] = isCancelling;
    $[107] = isSessionToday;
    $[108] = onCancel;
    $[109] = registration.id;
    $[110] = registration.status;
    $[111] = t;
    $[112] = t37;
  } else {
    t37 = $[112];
  }
  let t38;
  if ($[113] !== t) {
    t38 = t("account.registrations.actions.view", "VIEW");
    $[113] = t;
    $[114] = t38;
  } else {
    t38 = $[114];
  }
  let t39;
  if ($[115] !== handleViewRegistration || $[116] !== t38) {
    t39 = <button type="button" onClick={handleViewRegistration} className="w-22 h-8 bg-black text-white font-medium text-xs md:text-sm  hover:bg-gray-800 transition-colors">{t38}</button>;
    $[115] = handleViewRegistration;
    $[116] = t38;
    $[117] = t39;
  } else {
    t39 = $[117];
  }
  let t40;
  if ($[118] !== t37 || $[119] !== t39) {
    t40 = <div className="flex gap-2 justify-end mt-auto md:hidden">{t37}{t39}</div>;
    $[118] = t37;
    $[119] = t39;
    $[120] = t40;
  } else {
    t40 = $[120];
  }
  let t41;
  if ($[121] !== t22 || $[122] !== t28 || $[123] !== t35 || $[124] !== t36 || $[125] !== t40) {
    t41 = <div className="bg-white md:bg-[#F5F5F5] p-4 md:p-6 flex flex-col">{t22}{t28}{t35}{t36}{t40}</div>;
    $[121] = t22;
    $[122] = t28;
    $[123] = t35;
    $[124] = t36;
    $[125] = t40;
    $[126] = t41;
  } else {
    t41 = $[126];
  }
  return t41;
}
function _temp6(el) {
  if (!el) {
    return false;
  }
  const styles = window.getComputedStyle(el);
  const lhRaw = styles.lineHeight;
  const fontSize = parseFloat(styles.fontSize || "16");
  const lineHeight = lhRaw === "normal" || isNaN(parseFloat(lhRaw)) ? fontSize * 1.2 : parseFloat(lhRaw);
  const height = el.getBoundingClientRect().height;
  return height <= lineHeight + 0.5;
}